// extracted by mini-css-extract-plugin
export default {"headerWrap":"header_headerWrap__Ywwkb","logowrap":"header_logowrap__w015B","headerRight":"header_headerRight__fl-ud"};